import { FC } from "react";
import { useTranslation } from 'react-i18next';

interface IProps {
  value1: string;
  onChange1: (event: any) => void;
  value2: string;
  onChange2: (event: any) => void;
  disabled: boolean;  
}

const MonthInputBox: FC<IProps> = ({
  value1, onChange1, value2, onChange2, disabled
}) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-justify-center my-1">
      <div className="v-line">{t('homepage.tuition.text3')}</div>
      <input
        type="number"
        className="form-control mx-1 w-60p"
        value={value1}
        onChange={onChange1}
        disabled={disabled}
      />
      <div className="v-line">*</div>
      <input
        type="number"
        className="form-control mx-1 w-60p"
        value={value2}
        onChange={onChange2}
        disabled={disabled}
      />
      <div className="v-line">{t('homepage.tuition.text4')}</div>
    </div>
  );
}

export default MonthInputBox;
